
const AppOutpatient = () => import('./outpatient.vue');

const OutpatientSetup = () => import('./outpatient-setup/outpatient-setup.vue') 

const ClinicTagsList  = () => import('./outpatient-setup/clinic-tags-list/clinic-tags-list.vue')
const Housing         = () => import('./outpatient-setup/housing/housing.vue')
 
const OutpatientReservation = () => import('./outpatient-reservation/outpatient-reservation.vue') 
 
const AppointmentBooking    = () => import('./outpatient-reservation/appointment-booking/appointment-booking.vue')
  
//Guards
import { guardRoute } from '../guardRouter';
//Localization
import localeEn from '../../locales/en'
import localeAr from '../../locales/ar'

export const translation = {
    en: {
        ...localeEn
    },
    ar: {
        ...localeAr
    }
}

const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');

const OutpatientRoutes = [{
    path: '/outpatient',
    component: AppOutpatient,
    name: 'app.Outpatient',
    meta: {
        title: translation[lang].Nav.Outpatient.Outpatient
    },
    children: [ 
        {
            path: 'outpatient-setup',
            name: 'outpatient-setup',
            component: OutpatientSetup,

            meta: {
                 title: translation[lang].Nav.Outpatient.OutpatientSetup,
            },
            children: [
                {
                    path: 'clinic-tags-list',
                    name: '/outpatient/outpatient-setup/clinic-tags-list',
                    component: ClinicTagsList,

                    meta: {
                        title: translation[lang].Nav.Outpatient.ClinicTagsLists,
                        clickable: true
                    },
                },
                {
                    path: 'housing',
                    name: '/outpatient/outpatient-setup/housing',
                    component: Housing,

                    meta: {
                        title: translation[lang].Nav.Outpatient.Housing,
                        clickable: true
                    },
                }

            ],

        } ,
        {
            path: 'outpatient-reservation',
            name: 'outpatient-reservation',
            component: OutpatientReservation,

            meta: {
                 title: translation[lang].Nav.Outpatient.OutpatientReservation,
            },
            children: [ 
                {
                    path: 'appointment-booking',
                    name: '/outpatient/outpatient-reservation/appointment-booking',
                    component: AppointmentBooking,

                    meta: {
                        title: translation[lang].Nav.Outpatient.AppointmentBooking,
                        clickable: true
                    },
                }

            ],

        } 
    ],

    beforeEnter: guardRoute

}];

export default OutpatientRoutes;